import { UserService } from '../../services/user.service';

export function getPermissions(userService: UserService) {
  return userService.currentUser.role;
}

export function getSeeLicenses(permissions: any) {
  return permissions.licencias;
}

export function getSeeSkuld(permissions: any, userService: UserService) {
  if (permissions.skuld && userService.currentUser.role.units.length > 1) {
    return true;
  } else {
    return false;
  }
}

export function getAnaUnit(userService: UserService) {
  let ana = userService.currentUser.role.units.find(
    (element) => element.code == 'AN'
  );
  if (ana) {
    return ana._id;
  } else {
    return false;
  }
}

export function getSeeAna(userService: UserService) {
  let ANA = userService.currentUser.role.units.find(
    (element) => element.code == 'AN'
  );

  if (ANA != undefined) {
    return true;
  } else {
    return false;
  }
}

export function getUserUnits(userService: UserService) {
  let role = userService.currentUser?.role;
  let roleunits = role.units.filter((unit) => unit.code != 'AN');
  let units = roleunits.map((unit) => {
    // routeName es opcional en el formulario de Unidades: sin él se usa el nombre
    const name = unit.routeName || unit.name;
    const nunit = {
      link: `/cases/${unit._id}`,
      name,
      exact: true,
      active: false,

      click: `selectedOption/${name}`,
      if: true,
    };
    if (unit.code == 'ALT') {
      nunit.link = `/alerts/${unit._id}`;
      nunit.name = 'Alertas';
      nunit.click = `selectedOption/Alertas`;
    }
    return nunit;
  });
  units.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  return units;
}

export function getSklud(userService: UserService) {
  let units;
  let FRD = userService.currentUser.role.units.find(
    (element) => element.code == 'ALT'
  );

  if (FRD) {
    units = [
      {
        link: `/alerts/${FRD._id}`,
        name: 'Alertas',
        exact: true,
        active: false,

        click: 'selectedOption/Alertas',
        if: true,
      },
    ];

    return ([] as any[]).concat(...units);
  }
}

export function getSeeUsers(permissions: any) {
  const { createUsers, editUsers, deleteUsers } = permissions;
  return createUsers || editUsers || deleteUsers;
}

export function getSeeRoles(permissions: any) {
  const { editRoles, createRoles, deleteRoles } = permissions;
  return editRoles || createRoles || deleteRoles;
}

export function getImmersionPermission(permissions: any) {
  const { immersion } = permissions;
  return immersion;
}

export function getForskerPermission(permissions: any) {
  const { immersion } = permissions;
  return immersion;
}

export function getSeeLogSistemControl(permissions: any) {
  return permissions.seeLogSistemControl;
}

export function getSeeLogCases(permissions: any) {
  return permissions.seeLogCases;
}

export function getSeeMainReports(permissions: any) {
  return permissions.seeMainReports;
}

export function getSeeStatusConection(permissions: any) {
  return permissions.seeStatusConection;
}

export function getSeeTimer(permissions: any) {
  return permissions.seeTimer;
}

export function getSeeUnits(permissions: any) {
  const {
    createCaseType,
    editCaseType,
    deleteCaseType,
    editTask,
    createTask,
    deleteTask,
  } = permissions;

  return (
    createCaseType ||
    editCaseType ||
    deleteCaseType ||
    editTask ||
    createTask ||
    deleteTask
  );
}
